var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-col",
    {
      attrs: {
        cols: "12"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c(
            "gg-card-header",
            [
              _c("gg-card-title", [
                _vm._v(" Domain Transfer "),
                _c(
                  "div",
                  {
                    staticClass: "subtitle-2 font-light",
                    staticStyle: {
                      color: "gray"
                    }
                  },
                  [
                    _vm._v(" Transfer your domain to GreenGeeks in a few "),
                    _c(
                      "span",
                      {
                        staticClass: "font-italic"
                      },
                      [_vm._v("simple steps")]
                    ),
                    _vm._v(". ")
                  ]
                )
              ])
            ],
            1
          ),
          _c(
            "gg-card-text",
            [
              _c(
                "div",
                {
                  staticClass: "pt-4 pl-4 pr-4"
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "body-1"
                    },
                    [_vm._v(" Alright, let's prepare your domain transfer! ")]
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "body-1"
                    },
                    [
                      _vm._v(
                        " By submitting your request, you acknowledge you have read and understood our "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://www.greengeeks.com/support/article/domain-transfer-instructions-primary-domain/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Domain Transfer Instructions")]
                      ),
                      _vm._v(". ")
                    ]
                  )
                ]
              ),
              _c(
                "v-form",
                {
                  on: {
                    submit: function submit($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "grid-size-md",
                      attrs: {
                        fluid: ""
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pb-0",
                              attrs: {
                                cols: "12",
                                sm: "6"
                              }
                            },
                            [
                              _c("gg-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: _vm.rulesStep1.domain,
                                    expression: "rulesStep1.domain"
                                  }
                                ],
                                ref: "domainInput",
                                attrs: {
                                  label: "Domain Name",
                                  outlined: "",
                                  "data-vv-name": "domain",
                                  "data-vv-as": "Domain name",
                                  "error-messages": _vm.errors.collect(
                                    "domain"
                                  ),
                                  disabled: _vm.disabledForm
                                },
                                on: {
                                  input: _vm.onDomainChange,
                                  keyup: function keyup($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.checkPricing($event)
                                  }
                                },
                                model: {
                                  value: _vm.model.domain,
                                  callback: function callback($$v) {
                                    _vm.$set(_vm.model, "domain", $$v)
                                  },
                                  expression: "model.domain"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-container",
                {
                  staticClass: "grid-size-md",
                  attrs: {
                    fluid: ""
                  }
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "px-0 pb-5"
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pt-0",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                loading: _vm.checkingPrice,
                                disabled: !_vm.canCheckPrice
                              },
                              on: {
                                click: _vm.checkPricing
                              }
                            },
                            [_vm._v("Check Pricing")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.showAdditionalInformation
                ? _c(
                    "gg-card",
                    {
                      staticClass: "mb-4"
                    },
                    [
                      _c(
                        "gg-card-header",
                        [
                          _c("gg-card-title", [
                            _vm._v(" Additional Information ")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "v-form",
                            {
                              on: {
                                submit: function submit($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              _c(
                                "v-container",
                                {
                                  staticClass: "grid-size-md",
                                  attrs: {
                                    fluid: ""
                                  }
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _vm.domainTransferResponse
                                        .tld_require_eppcode
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0",
                                              attrs: {
                                                cols: "12",
                                                sm: "6"
                                              }
                                            },
                                            [
                                              _c("gg-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      _vm.eppValidationRules,
                                                    expression:
                                                      "eppValidationRules"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "EPP transfer code",
                                                  hint: "Authorization code",
                                                  outlined: "",
                                                  "data-vv-name": "epp",
                                                  "data-vv-as":
                                                    "EPP transfer code",
                                                  "error-messages": _vm.errors.collect(
                                                    "epp"
                                                  )
                                                },
                                                on: {
                                                  keydown: function keydown(
                                                    $event
                                                  ) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    return _vm.submitRequest(
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.model.epp_code,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "epp_code",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "model.epp_code"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.domainTransferResponse
                                        .tld_idprotect_available
                                        ? _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                cols: "12",
                                                sm: "6"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-radio-group",
                                                {
                                                  attrs: {
                                                    label:
                                                      "Include Whois Privacy",
                                                    hint:
                                                      "See FAQ below for details",
                                                    "persistent-hint": ""
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model
                                                        .include_whois_privacy,
                                                    callback: function callback(
                                                      $$v
                                                    ) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "include_whois_privacy",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.include_whois_privacy"
                                                  }
                                                },
                                                [
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "No",
                                                      value: false
                                                    }
                                                  }),
                                                  _c("v-radio", {
                                                    attrs: {
                                                      label: "Yes",
                                                      value: true
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm.extendedAttributes.length
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "pt-5 pb-0"
                                                },
                                                [
                                                  _c("h4", [
                                                    _vm._v(
                                                      "Extended Attributes"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "pb-0"
                                                },
                                                [
                                                  _vm.domainTransferResponse
                                                    .tld === "ca"
                                                    ? _c("p", [
                                                        _vm._v(
                                                          " You must read and agree to the "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                "https://www.cira.ca/uploads/2023/06/Registrant-Agreement-Version-2.2_0.pdf",
                                                              target: "_newwin"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "CIRA Registrant Agreement"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " to register a .CA domain. "
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  _vm.domainTransferResponse
                                                    .tld === "eu"
                                                    ? _c("p", [
                                                        _vm._v(
                                                          " You must read and agree to the "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                "https://cdn.eurid.eu/assets/registration_data_verification_policy-2.pdf",
                                                              target: "_newwin"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "EURID Registration Data Verification Policy"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " to register a .EU domain. "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.extendedAttributes,
                                            function(extendedAttribute) {
                                              return _c(
                                                "v-row",
                                                {
                                                  key:
                                                    extendedAttribute.model.name
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "gg-input-label",
                                                        {
                                                          staticClass:
                                                            "d-block pb-1"
                                                        },
                                                        [
                                                          _c("span", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                extendedAttribute.description
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      extendedAttribute.type ===
                                                      "select"
                                                        ? _c(
                                                            "gg-autocomplete",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    _vm
                                                                      .extAttributesRules[
                                                                      "".concat(
                                                                        extendedAttribute
                                                                          .model
                                                                          .name
                                                                      )
                                                                    ],
                                                                  expression:
                                                                    "extAttributesRules[`${extendedAttribute.model.name}`]"
                                                                }
                                                              ],
                                                              attrs: {
                                                                searchable: "",
                                                                dense: "",
                                                                outlined: "",
                                                                filter:
                                                                  _vm.filter,
                                                                items:
                                                                  extendedAttribute.options,
                                                                "item-value":
                                                                  "Value",
                                                                "data-vv-name": "".concat(
                                                                  extendedAttribute
                                                                    .model.name
                                                                ),
                                                                "error-messages": _vm.errors.collect(
                                                                  "".concat(
                                                                    extendedAttribute
                                                                      .model
                                                                      .name
                                                                  )
                                                                )
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "selection",
                                                                    fn: function fn(
                                                                      _ref
                                                                    ) {
                                                                      var item =
                                                                        _ref.item
                                                                      return [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item.Title
                                                                            ) +
                                                                            " "
                                                                        )
                                                                      ]
                                                                    }
                                                                  },
                                                                  {
                                                                    key: "item",
                                                                    fn: function fn(
                                                                      _ref2
                                                                    ) {
                                                                      var item =
                                                                        _ref2.item
                                                                      return [
                                                                        _c(
                                                                          "v-row",
                                                                          [
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                attrs: {
                                                                                  cols:
                                                                                    "11"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      item.Title
                                                                                    ) +
                                                                                    " "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            typeof item.Description ===
                                                                              "string" &&
                                                                            item.Description !==
                                                                              item.Title
                                                                              ? _c(
                                                                                  "v-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      cols:
                                                                                        "1"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-tooltip",
                                                                                      {
                                                                                        attrs: {
                                                                                          bottom:
                                                                                            "",
                                                                                          "max-width":
                                                                                            "600"
                                                                                        },
                                                                                        scopedSlots: _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key:
                                                                                                "activator",
                                                                                              fn: function fn(
                                                                                                _ref3
                                                                                              ) {
                                                                                                var on =
                                                                                                    _ref3.on,
                                                                                                  attrs =
                                                                                                    _ref3.attrs
                                                                                                return [
                                                                                                  _c(
                                                                                                    "v-icon",
                                                                                                    _vm._g(
                                                                                                      _vm._b(
                                                                                                        {
                                                                                                          attrs: {
                                                                                                            color:
                                                                                                              "primary",
                                                                                                            dark:
                                                                                                              ""
                                                                                                          }
                                                                                                        },
                                                                                                        "v-icon",
                                                                                                        attrs,
                                                                                                        false
                                                                                                      ),
                                                                                                      on
                                                                                                    ),
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        " mdi-alert-outline "
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              }
                                                                                            }
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        )
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            domProps: {
                                                                                              innerHTML: _vm._s(
                                                                                                item.Description
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              : _vm._e()
                                                                          ],
                                                                          1
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              ),
                                                              model: {
                                                                value:
                                                                  extendedAttribute
                                                                    .model
                                                                    .value,
                                                                callback: function callback(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    extendedAttribute.model,
                                                                    "value",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "extendedAttribute.model.value"
                                                              }
                                                            }
                                                          )
                                                        : extendedAttribute.type ===
                                                          "input"
                                                        ? _c("gg-text-field", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  _vm
                                                                    .extAttributesRules[
                                                                    "".concat(
                                                                      extendedAttribute
                                                                        .model
                                                                        .name
                                                                    )
                                                                  ],
                                                                expression:
                                                                  "extAttributesRules[`${extendedAttribute.model.name}`]"
                                                              }
                                                            ],
                                                            attrs: {
                                                              outlined: "",
                                                              "data-vv-name": "".concat(
                                                                extendedAttribute
                                                                  .model.name
                                                              ),
                                                              "error-messages": _vm.errors.collect(
                                                                "".concat(
                                                                  extendedAttribute
                                                                    .model.name
                                                                )
                                                              )
                                                            },
                                                            model: {
                                                              value:
                                                                extendedAttribute
                                                                  .model.value,
                                                              callback: function callback(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  extendedAttribute.model,
                                                                  "value",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "extendedAttribute.model.value"
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.hideSummary
                ? _c(
                    "gg-card",
                    {
                      staticClass: "mb-4"
                    },
                    [
                      _c(
                        "gg-card-header",
                        [_c("gg-card-title", [_vm._v(" Summary ")])],
                        1
                      ),
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "font-bold",
                                      attrs: {
                                        cols: "2"
                                      }
                                    },
                                    [_vm._v(" Transfer Cost: ")]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "10"
                                      }
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.priceWithFreeDomain(
                                              _vm.formatPrice(
                                                _vm.domainTransferPrice
                                              )
                                            )
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm.showDetailedPrice
                                ? [
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "font-bold",
                                            attrs: {
                                              cols: "2"
                                            }
                                          },
                                          [_vm._v(" Privacy Cost: ")]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "10"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatPrice(
                                                    _vm.idProtectPrice
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "font-bold",
                                            attrs: {
                                              cols: "2"
                                            }
                                          },
                                          [_vm._v(" Total: ")]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "10"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatPrice(
                                                    _vm.domainTransferPriceTotal
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "font-bold",
                                      attrs: {
                                        cols: "2"
                                      }
                                    },
                                    [_vm._v(" Created On: ")]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "10"
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(_vm.nowDate()) + " ")]
                                  )
                                ],
                                1
                              ),
                              !_vm.domainTransferResponse.tld_auto_transfer
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass: "px-1 pb-1"
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pt-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "px-0",
                                              attrs: {
                                                cols: "12"
                                              }
                                            },
                                            [
                                              _c("v-checkbox", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      _vm.confirmationValidationRules,
                                                    expression:
                                                      "confirmationValidationRules"
                                                  }
                                                ],
                                                staticClass: "mt-0",
                                                attrs: {
                                                  color: "primary",
                                                  "data-vv-name":
                                                    "confirmationRule",
                                                  "error-messages": _vm.errors.collect(
                                                    "confirmationRule"
                                                  ),
                                                  "aria-label":
                                                    "I confirm the details of my domain transfer request are correct. I agree to the Domain Transfer Instructions and ICANN policies.",
                                                  ripple: true
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function fn() {
                                                        return [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "v-label",
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer"
                                                              },
                                                              attrs: {
                                                                "aria-hidden":
                                                                  "true"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "I confirm the details of my domain transfer request are correct. I agree to the Domain Transfer Instructions and ICANN policies."
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      },
                                                      proxy: true
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  2545380403
                                                ),
                                                model: {
                                                  value:
                                                    _vm.model.requestConfirmed,
                                                  callback: function callback(
                                                    $$v
                                                  ) {
                                                    _vm.$set(
                                                      _vm.model,
                                                      "requestConfirmed",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "model.requestConfirmed"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "gg-btn",
                                            {
                                              staticClass: "mr-4",
                                              attrs: {
                                                loading: _vm.submittingRequest,
                                                disabled: _vm.canCheckPrice
                                              },
                                              on: {
                                                click: _vm.submitRequest
                                              }
                                            },
                                            [_vm._v("Submit Request")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.domainTransferResponse.tld_auto_transfer
                ? _c(
                    "gg-card",
                    {
                      staticClass: "mb-4"
                    },
                    [
                      _c(
                        "gg-card-header",
                        [_c("gg-card-title", [_vm._v(" Payment ")])],
                        1
                      ),
                      _c(
                        "gg-card-text",
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "grid-size-md",
                              attrs: {
                                fluid: ""
                              }
                            },
                            [
                              _c("payment-gateway", {
                                ref: "paymentGateway",
                                attrs: {
                                  compact: "",
                                  "with-redeem": "",
                                  "card-selection-label": _vm.cardLabel,
                                  "with-free-domain-migration":
                                    _vm.isWithFreeDomainMigration,
                                  "free-domain-options": _vm.freeDomainOptions,
                                  "price-with-free-domain": _vm.model
                                    .include_whois_privacy
                                    ? _vm.domainTransferPriceTotal
                                    : 0
                                },
                                on: {
                                  gateway: _vm.listenGateway,
                                  card: _vm.listenCard,
                                  "card-switch": _vm.listenCardNew
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "header",
                                      fn: function fn() {
                                        return [
                                          _vm._v("Domain Transfer Payment")
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1422324275
                                )
                              }),
                              _c(
                                "v-row",
                                {
                                  staticClass: "px-0 pb-1"
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-0",
                                      attrs: {
                                        cols: "12"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "px-0",
                                          attrs: {
                                            cols: "12"
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value:
                                                  _vm.confirmationValidationRules,
                                                expression:
                                                  "confirmationValidationRules"
                                              }
                                            ],
                                            staticClass: "mt-0",
                                            attrs: {
                                              color: "primary",
                                              "data-vv-name":
                                                "confirmationRule",
                                              "error-messages": _vm.errors.collect(
                                                "confirmationRule"
                                              ),
                                              "aria-label":
                                                "I confirm the details of my domain transfer request are correct. I agree to the Domain Transfer Instructions and ICANN policies.",
                                              ripple: true
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function fn() {
                                                    return [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "v-label",
                                                          staticStyle: {
                                                            cursor: "pointer"
                                                          },
                                                          attrs: {
                                                            "aria-hidden":
                                                              "true"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "I confirm the details of my domain transfer request are correct. I agree to the Domain Transfer Instructions and ICANN policies."
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              2545380403
                                            ),
                                            model: {
                                              value: _vm.model.requestConfirmed,
                                              callback: function callback($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "requestConfirmed",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.requestConfirmed"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "gg-btn",
                                        {
                                          staticClass: "mr-4",
                                          attrs: {
                                            loading: _vm.submittingRequest,
                                            disabled: _vm.canCheckPrice
                                          },
                                          on: {
                                            click: _vm.submitTransfer
                                          }
                                        },
                                        [_vm._v("Submit Transfer")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }